import { I18N } from "./I18N.js"

export class CartMini {
	_target
	_onOrderUpdatedHandlers = []
	_store
	_cartVO
	_cartPark = []

	constructor(target) {
		this._target = document.getElementById(target)
		this._target.innerHTML = `
			<div>
				<span class="material-icons-outlined">shopping_cart</span></div>
			<div id="itemsCount" hidden>-</div>
		`
		this._target.setAttribute('disabled', '')
		I18N.translateElement(this._target)
	}

	setCartVO = cartVO => {
		const itemCnt = this._getItemCnt(cartVO)
		if (itemCnt > 0) {
			document.getElementById('itemsCount').innerHTML = itemCnt
			document.getElementById('itemsCount').removeAttribute('hidden')
			this._target.removeAttribute('disabled')
		}
		else {
			document.getElementById('itemsCount').innerHTML = '-'
			document.getElementById('itemsCount').setAttribute('hidden', '')
			this._target.setAttribute('disabled', '')
		}
	}

	_getItemCnt = cartVO => {
		let nr = 0
		if (cartVO && cartVO.items && cartVO.items.length) {
			cartVO.items.forEach(item => {
				nr += item.qty
			})
		}
		return nr
	}

}